import { MenuProps } from "@mui/material";

import SideNavMenu from "@app/analytics/components/SideNav/SideNavMenu";

import LocaleMenuItems from "./LocaleMenuItems";

interface Props extends MenuProps {
  onClose: () => void;
}

/** Menu used on Desktop site */
const LocaleMenu = ({ onClose, ...props }: Props) => (
  <SideNavMenu
    disableAutoFocusItem
    disableScrollLock
    onClose={onClose}
    {...props}
  >
    <LocaleMenuItems onClose={onClose} />
  </SideNavMenu>
);

export default LocaleMenu;
